var map = {
	"./chicken/packet1.png": 62,
	"./spinosaurus/packet1.png": 9077,
	"./trex/packet1.png": 9846,
	"./triceratops/packet1.png": 223,
	"./velociraptor/packet1.png": 9179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9959;